import Header from './header';

interface MainLayoutProps extends HocProps {
  showFooter?: boolean;
}
export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div>
      <Header />
      {children}
    </div>
  );
};
